import { IBuilderTask } from './reducer';

interface IInitEmptyBuilderPath {
    type: 'INIT_EMPTY_BUILDER_PATH';
    name: string;
}

export function initEmptyBuilderPath(name: string): IInitEmptyBuilderPath {
    return {
        type: 'INIT_EMPTY_BUILDER_PATH',
        name,
    };
}

interface IBuilderTaskOnPath {
    id: string;
    builderTask: IBuilderTask;
}

interface IInitBuilderPath {
    type: 'INIT_BUILDER_PATH';
    name: string;
    showThemes: boolean;
    showMiles: boolean;
    showLength: boolean;
    showPrice: boolean;
    tasks: IBuilderTask[];
}

export function initBuilderPath(
    name: string,
    showThemes: boolean,
    showMiles: boolean,
    showLength: boolean,
    showPrice: boolean,
    taskOnPaths: IBuilderTaskOnPath[],
): IInitBuilderPath {
    const tasks = taskOnPaths.map(top => top.builderTask);
    return {
        type: 'INIT_BUILDER_PATH',
        name,
        showThemes,
        showMiles,
        showLength,
        showPrice,
        tasks,
    };
}

interface ISetModalTask {
    type: 'SET_MODAL_TASK';
    task: IBuilderTask;
    index: number | null;
}

export function setModalTask(task: IBuilderTask, index: number | null = null): ISetModalTask {
    return {
        type: 'SET_MODAL_TASK',
        task,
        index,
    };
}

interface IAddTaskToPath {
    type: 'ADD_TASK_TO_PATH';
    task: IBuilderTask;
    where: 'start' | 'end';
}

export function addTaskToPath(task: IBuilderTask, where: 'start' | 'end'): IAddTaskToPath {
    return {
        type: 'ADD_TASK_TO_PATH',
        task,
        where,
    };
}

interface IAddTaskToPathAtIndex {
    type: 'ADD_TASK_TO_PATH_AT_INDEX';
    task: IBuilderTask;
    index: number;
}

export function addTaskToPathAtIndex(task: IBuilderTask, index: number): IAddTaskToPathAtIndex {
    return {
        type: 'ADD_TASK_TO_PATH_AT_INDEX',
        task,
        index,
    };
}

interface IRemoveTaskFromPath {
    type: 'REMOVE_TASK_FROM_PATH';
    index: number;
}

export function removeTaskFromPath(index: number): IRemoveTaskFromPath {
    return {
        type: 'REMOVE_TASK_FROM_PATH',
        index,
    };
}

interface IMoveTaskOnPath {
    type: 'MOVE_TASK_ON_PATH';
    index: number;
    target: 'start' | 'end' | number;
}

export function moveTaskOnPath(index: number, target: 'start' | 'end' | number): IMoveTaskOnPath {
    return {
        type: 'MOVE_TASK_ON_PATH',
        index,
        target,
    };
}

interface IUpdatePathName {
    type: 'UPDATE_PATH_NAME';
    name: string;
}

export function updatePathName(name: string): IUpdatePathName {
    return {
        type: 'UPDATE_PATH_NAME',
        name,
    };
}

interface IToggleShowThemes {
    type: 'TOGGLE_SHOW_THEMES';
    to: boolean;
}

export function toggleShowThemes(to: boolean): IToggleShowThemes {
    return {
        type: 'TOGGLE_SHOW_THEMES',
        to,
    };
}

interface IToggleShowMiles {
    type: 'TOGGLE_SHOW_MILES';
    to: boolean;
}

export function toggleShowMiles(to: boolean): IToggleShowMiles {
    return {
        type: 'TOGGLE_SHOW_MILES',
        to,
    };
}
interface IToggleShowLength {
    type: 'TOGGLE_SHOW_LENGTH';
    to: boolean;
}

export function toggleShowLength(to: boolean): IToggleShowLength {
    return {
        type: 'TOGGLE_SHOW_LENGTH',
        to,
    };
}

interface IToggleShowPrice {
    type: 'TOGGLE_SHOW_PRICE';
    to: boolean;
}

export function toggleShowPrice(to: boolean): IToggleShowPrice {
    return {
        type: 'TOGGLE_SHOW_PRICE',
        to,
    };
}

export type IBuilderActions =
    | IInitBuilderPath
    | ISetModalTask
    | IAddTaskToPath
    | IRemoveTaskFromPath
    | IAddTaskToPathAtIndex
    | IMoveTaskOnPath
    | IUpdatePathName
    | IToggleShowThemes
    | IToggleShowMiles
    | IToggleShowLength
    | IToggleShowPrice
    | IInitEmptyBuilderPath;
